"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var FirstStep_1 = __importDefault(require("./FirstStep"));
var Confirm_1 = __importDefault(require("./Confirm"));
var Root = function (props) {
    var state = form_store_1.default.getState();
    var _a = (0, react_1.useState)(state.isComplete), isComplete = _a[0], setIsComplete = _a[1];
    var _b = (0, react_1.useState)(state.isNext), isNext = _b[0], setIsNext = _b[1];
    var _c = (0, react_1.useState)(true), isMounted = _c[0], setIsMounted = _c[1];
    form_store_1.default.on("STATE_CHANGE", function () {
        var state = form_store_1.default.getState();
        if (isMounted) {
            setIsComplete(state.isComplete);
            setIsNext(state.isNext);
        }
    });
    if (isNext) {
        return (react_1.default.createElement(Confirm_1.default, null));
    }
    else {
        return (react_1.default.createElement(FirstStep_1.default, null));
    }
};
exports.default = Root;
